// TagTable.jsx
import moment from "moment";
import { useTranslation } from "react-i18next";
import InfinityTable from "../../../components/infinity-table/infinity-table";

const TagTable = ({
  data,
  fetchData,
  hasMore,
  isLoading,
  onHandleRowClick,
  sorting,
  onSortingChange,
  selectionColumn,
  containerRef,
  after,
}) => {
  const { t } = useTranslation();

  const toAntOrder = (o) => (o === "ASC" ? "ascend" : o === "DESC" ? "descend" : null);

  const columns = [
    {
      title: t("administration.tag.table.name"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortOrder: sorting?.sortField === "name" ? toAntOrder(sorting.sortOrder) : null,
    },
    {
      title: t("administration.tag.table.source"),
      dataIndex: "source",
      key: "source",
      sorter: true,
      sortOrder: sorting?.sortField === "source" ? toAntOrder(sorting.sortOrder) : null,
    },
    {
      title: t("administration.tag.table.last_modified"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: true,
      sortOrder: sorting?.sortField === "updatedAt" ? toAntOrder(sorting.sortOrder) : null,
      render: (_, tag) => `${moment(tag.updatedAt).utc().format("DD MMM YYYY, HH:mm")}, UTC`,
    },
  ];

  const onChange = (_pagination, _filters, sorter) => {
    // ВАЖЛИВО: якщо користувач не обрав сортування — нічого не міняємо
    if (!sorter?.field || !sorter?.order) return;

    const next = {
      sortField: sorter.field,
      sortOrder: sorter.order === "ascend" ? "ASC" : "DESC",
    };

    // не апдейтимо стан, якщо він не змінився (уникаємо зайвих фетчів)
    if (
      next.sortField !== sorting?.sortField ||
      next.sortOrder !== sorting?.sortOrder
    ) {
      onSortingChange(next);
    }
  };

  const tableColumns = selectionColumn ? [selectionColumn, ...columns] : columns;

  return (
    <InfinityTable
      data={data}
      fetchData={fetchData}
      hasMore={hasMore}
      tableColumns={tableColumns}
      isLoading={isLoading}
      onHandleRowClick={onHandleRowClick}
      onChange={onChange}
      containerRef={containerRef}
      after={after}
    />
  );
};

export default TagTable;
